// src/lib/sample-data/settings.ts - Sample settings data
import type { AdminSettingsData, UserAccountSettings } from '@/lib/types';
// Note: User data now comes from Firebase Auth, using empty settings store

export const sampleAdminSettings: AdminSettingsData = {
  defaultFrontendLanguage: 'en-GB',
  timezone: 'Europe/Zurich',
  firstDayOfWeek: 'Monday',
  timeFormat: '24h',
  dateFormat: 'dd-mm-yyyy',
  defaultSpaceType: 'Court',
  currency: { code: 'CHF', symbol: 'Fr.' },
  customDomain: 'myclub.courtly.app',
  iban: 'CH9988776655443322',
  guestTotalFutureBookingHoursLimit: 2,
  guestMaxHoursPerDay: 1,
  guestCalendarVisibilityDays: 3,
  guestCancellationWindowHours: 1,
  memberTotalFutureBookingHoursLimit: 2,
  memberMaxHoursPerDay: 2,
  memberCalendarVisibilityDays: 7,
  memberCancellationWindowHours: 1,
  teacherTotalFutureBookingHoursLimit: 16,
  teacherMaxHoursPerDay: 4,
  teacherCancellationWindowHours: 0,
  teacherCalendarVisibilityDays: 30,
  tennisSchoolTotalFutureBookingHoursLimit: 20,
  tennisSchoolMaxHoursPerDay: 4,
  tennisSchoolCalendarVisibilityDays: 60,
  tennisSchoolCancellationWindowHours: 1,
  tennisClubTotalFutureBookingHoursLimit: 8,
  tennisClubMaxHoursPerDay: 4,
  tennisClubCalendarVisibilityDays: 30,
  tennisClubCancellationWindowHours: 1,
};

// Sample account settings for demo users
export const sampleAccountSettingsStore: { [userId: string]: UserAccountSettings } = {
  // Roger Federer (Admin) - 2847391650
  '2847391650': {
    userUid: '2847391650',
    notifications: {
      bookingConfirmations: true,
      bookingReminders: true,
      promotions: false,
    },
    appearance: {
      language: 'en',
    },
    display: {
      defaultView: 'week',
    },
  },
  
  // John McEnroe (Admin) - 4567891230
  '4567891230': {
    userUid: '4567891230',
    notifications: {
      bookingConfirmations: true,
      bookingReminders: false,
      promotions: true,
    },
    appearance: {
      language: 'en',
    },
    display: {
      defaultView: 'month',
    },
  },
  
  // Venus Williams (Admin) - 5678912340
  '5678912340': {
    userUid: '5678912340',
    notifications: {
      bookingConfirmations: true,
      bookingReminders: true,
      promotions: false,
    },
    appearance: {
      language: 'en',
    },
    display: {
      defaultView: 'day',
    },
  },
  
  // Amélie Mauresmo (Admin) - 6789123450
  '6789123450': {
    userUid: '6789123450',
    notifications: {
      bookingConfirmations: false,
      bookingReminders: true,
      promotions: false,
    },
    appearance: {
      language: 'en',
    },
    display: {
      defaultView: 'week',
    },
  },
  
  // Maria Sharapova (Teacher) - 4051728396
  '4051728396': {
    userUid: '4051728396',
    notifications: {
      bookingConfirmations: true,
      bookingReminders: true,
      promotions: true,
    },
    appearance: {
      language: 'en',
    },
    display: {
      defaultView: 'day',
    },
  },
  
  // Mark Guest (Guest) - 9182736450
  '9182736450': {
    userUid: '9182736450',
    notifications: {
      bookingConfirmations: true,
      bookingReminders: false,
      promotions: false,
    },
    appearance: {
      language: 'en',
    },
    display: {
      defaultView: 'week',
    },
  },
};
